// src/pages/Dashboard/Admin/Coaching/components/DashboardCoachingHeader.jsx

import React from "react";
import { FaSyncAlt, FaUserTie } from "react-icons/fa";

export default function DashboardCoachingHeader({ onRefresh }) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-5 sm:p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Coaching
            </p>

            <h1 className="mt-1 flex items-center gap-3 text-2xl font-bold text-slate-900 dark:text-white">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300">
                <FaUserTie />
              </span>
              Gestion des heures de coaching
            </h1>

            <p className="mt-2 max-w-4xl text-sm leading-6 text-slate-600 dark:text-slate-300">
              Suivez les heures de coaching par enseignant, modifiez les heures
              enregistrées sur les événements et visualisez une synthèse globale
              du club.
            </p>

            <p className="mt-1 max-w-4xl text-xs leading-5 text-slate-500 dark:text-slate-400">
              La création initiale des heures de coaching se fait depuis la page
              de suivi des compétitions de l’enseignant, dans la fenêtre résultat.
            </p>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            <FaSyncAlt />
            Actualiser
          </button>
        </div>
      </div>
    </section>
  );
}